import type useInternalLinks from '@/hooks/useInternalLinks';

const getInternalPageUrl = ({
  internalPageAction,
  getInternalLinkByCodename,
}: {
  internalPageAction: Queries.LINK_ACTION_INTERNAL_PAGEFragment;
  getInternalLinkByCodename: ReturnType<typeof useInternalLinks>;
}): string | undefined => {
  const { page, building_block_wrapper } = internalPageAction.elements;
  const pageUrl = getInternalLinkByCodename(page.value.system.codename);

  if (!pageUrl) {
    return undefined;
  }

  // NOTE get the anchor id from the building block wrapper if it provided
  const buildingBlockWrapper = building_block_wrapper?.value;
  const anchorId =
    buildingBlockWrapper && 'elements' in buildingBlockWrapper
      ? `#${buildingBlockWrapper.elements.anchor_id.value}`
      : '';

  return `${pageUrl}${anchorId}`;
};

export default getInternalPageUrl;
